export const awsconfig = {
    authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_PtwOBf1cW",
    client_id: "2obret4f8b2o9pg1nl75jntfha",
    redirect_uri: "https://www.polygonhealth.com/map/callback/",
    silent_redirect_uri: "https://www.polygonhealth.com/map/callback/",
    post_logout_redirect_uri: "https://www.polygonhealth.com/map/out/",
    metadataUrl: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_PtwOBf1cW/.well-known/openid-configuration",
    extraQueryParams: { client_id: "2obret4f8b2o9pg1nl75jntfha" },
    response_type: "code",
    scope: "email openid profile",
    //onSigninCallback: onSigninCallback,  
    //userStore: new WebStorageStateStore({ store: window.localStorage }) // or sessionStorage
  };
  export default awsconfig
  